/*
 * Sanitize through angular security checker for the given html string.
 *
 * @unstable
 */

import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml',
  standalone: false,
})
export class SanitizeHtml implements PipeTransform {
  readonly sanitizer = inject(DomSanitizer);

  public transform(html: string | null): SafeHtml | null {
    return this.sanitizer.sanitize(SecurityContext.HTML, html);
  }
}
